import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=f8183e34&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=f8183e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8183e34",
  null
  
)

export default component.exports